module.exports = __webpack_public_path__ + "static/media/PDF.1b1c75ca.svg";